import { createContext, useContext, useReducer } from "react";

export const FileShopStore = createContext<IContextProps>(null);

interface IContextProps {
    state: IState;
    dispatch: ({ type }: Dispatch) => void;
}

type Dispatch = { type, payload }

class Search {
    keywords: string;
    classesId: string;
    shop: any;
};

interface IState {
    classesList: any[];
    search: Search;
}

const initialArgs = {
    classesList: [],
    search: new Search()
}

function reducer(state: IState, { type, payload }: Dispatch) {
    switch (type) {
        case "LoadClasses":
            return {
                ...state,
                classesList: payload
            }
        case "SetSearch":
            return {
                ...state,
                search: {
                    ...state.search,
                    ...payload
                }
            }
        default:
            return state;
    }
}

export function FileShopStoreProvider(props) {
    const [state, dispatch] = useReducer(reducer, initialArgs);

    const v = { state, dispatch };
    return <FileShopStore.Provider value={v}>{props.children}</FileShopStore.Provider>
}